/* ./src/i18n.js */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ⌬ 1.1 測試：i18next-browser-languagedetector
import LanguageDetector from 'i18next-browser-languagedetector';

// import 翻譯文本
import en from './assets/i18n/en.json';
import tw from './assets/i18n/zh-TW.json';
import cn from './assets/i18n/zh-CN.json';
import jp from './assets/i18n/ja-JP.json';
import vi from './assets/i18n/vi.json'; // 如果有越南語翻譯文本，則引入

const resources = {
    'en': {
        title: "English (US)",
        translation: en, // 預載 英文文本
    },
    'vi': {
        title: "Tiếng Việt",
        translation: vi, // 預載 越南文文本
    },
    'zh-TW': {
        title: "繁體中文",
        translation: tw, // 預載 繁中
    },
    'zh-CN': {
        title: "简体中文",
        translation: cn, // 預載 簡中
    },
    'ja-JP': {
        title: "にほんご",
        translation: jp, // 預載 日本文本
    },
};

/* 測試刪除 localStorage */
// setInterval(() => {
//     localStorage.removeItem('i18nextLng');
// }, 5000);

i18n
    // ⌬ 1.2 測試：i18next-browser-languagedetector
    .use(LanguageDetector)
    // passes i18n down to react-i18next
    .use(initReactI18next)
    // init i18next
    .init({
        resources, // 🖈 i18next: 文本輸入
        // lng: navigator.language, // 🖈 i18next: 預設語言 (若有使用 i18next-browser-languagedetector 此行需註解掉)
        fallbackLng: 'en',     // 🖈 i18next: 如果當前切換的語言沒有對應的翻譯則使用這個語言，

        // ⌬ 1.3 測試：i18next-browser-languagedetector - 設定
        // ⟁ 需將 lng: ... 註解後，localsession 才會生效
        detection: {
            /**
             * Language的key值為：i18nextLng
             * 可參考：https://github.com/i18next/i18next-browser-languageDetector/blob/9efebe6ca0271c3797bc09b84babf1ba2d9b4dbb/src/index.js#L11
             */
            // caches: ['localStorage', 'sessionStorage', 'cookie'], // ⛚ 要寫入 'localStorage', 'sessionStorage', 'cookie'
            caches: ['localStorage'], // ⸎ 要寫入 'localStorage'
            lookupQuerystring: 'lng' || navigator.language,  // ⸎ lng會直接讀取 localsession的i18nextLng key值，假如沒寫入 lng 會直接載入瀏覽器預設語言
        }
    });

export default i18n;
export { resources }; // 不一定要export!! 只是為了方便 製作button或select文本，會用到。